import React, { useCallback } from 'react';
import "../../styles/home/item_section.css";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSearchContext } from "../chats/searchContext";

import searchIcon from "../../images/chats/search_icon.png";
import backArrowIcon from "../../images/back_arrow_icon_2.png";
import noImage from "../../images/collections/no_image.png";

const ItemSection = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {
        getOriginalActionList, getOriginalThrillerList, getOriginalComedyList, getOriginalHorrorList, 
        getOriginalFamilyList, getOriginalMysteryList, getOriginalAnimationList, getOriginalDramaList,
        getOriginalAdventureList, getOriginalRomanceList, getOriginalScienceFictionList, getOriginalNewsList,
        getOriginalKidsList, getOriginalRealityList, getOriginalSoapList, getOriginalTalkList, 
        getOriginalWarList, getOriginalWesternList, getOriginalHistoryList, getOriginalDocumentaryList,
        getOriginalFantasyList, getOriginalCrimeList, getOriginalMusicList,
    } = useSearchContext();

    const [getSearch, setSearch] = useState("");
    const [getSelectedSortOption, setSelectedSortOption] = useState("all");
    const [getIsLoading, setIsLoading] = useState(true);
    const [getItemError, setItemError] = useState("");
    const [getItemList, setItemList] = useState([]);

    const url = location.pathname.toString();
    const urlPart = url.split("/");
    const genreBrac = urlPart[urlPart.indexOf("home") + 1]
    let genredd = genreBrac.split("movies")[0];
    let genre = genredd.slice(0, -1);

    const GENRE_CONFIG = {
        thriller: {
            getOriginalList: getOriginalThrillerList,
        },
        mystery: {
            getOriginalList: getOriginalMysteryList,
        },
        family: {
            getOriginalList: getOriginalFamilyList,
        },
        horror: {
            getOriginalList: getOriginalHorrorList,
        },
        comedy: {
            getOriginalList: getOriginalComedyList,
        },
        animation: {
            getOriginalList: getOriginalAnimationList,
        },
        drama: {
            getOriginalList: getOriginalDramaList,
        },
        adventure: {
            getOriginalList: getOriginalAdventureList,
        },
        romance: {
            getOriginalList: getOriginalRomanceList,
        },
        "science-fiction": {
            getOriginalList: getOriginalScienceFictionList,
        },
        news: {
            getOriginalList: getOriginalNewsList,
        },
        action: {
            getOriginalList: getOriginalActionList,
        },
        kids: {
            getOriginalList: getOriginalKidsList,
        },
        reality: {
            getOriginalList: getOriginalRealityList,
        },
        soap: {
            getOriginalList: getOriginalSoapList,
        },
        talk: {
            getOriginalList: getOriginalTalkList,
        },
        war: {
            getOriginalList: getOriginalWarList,
        },
        western: {
            getOriginalList: getOriginalWesternList,
        },
        history: {
            getOriginalList: getOriginalHistoryList,
        },
        fantasy: {
            getOriginalList: getOriginalFantasyList,
        },
        documentary: {
            getOriginalList: getOriginalDocumentaryList,
        },
        crime: {
            getOriginalList: getOriginalCrimeList,
        },
        music: {
            getOriginalList: getOriginalMusicList,
        },
    };

    const goBack = () => {
        navigate(-1);
    };

    const onChangeSearch = (search) => {
        setSearch(search.target.value);
    };

    const onSortItems = (event) => {
        setSelectedSortOption(event.target.value);
    };

    const getCardSpace = () => {
        const parent = document.getElementById('action_container_home_screen_i');
        const parentWidth = parent.offsetWidth;
        const childWidth = window.innerWidth <= 600 ? 110 : 150 + 30;
        const numChildren = Math.floor(parentWidth / childWidth);
        parent.style.gridTemplateColumns = `repeat(${numChildren}, 1fr)`;
    };

    // const getAllGenre = async (type) => {
    //     const config = GENRE_CONFIG[type] || GENRE_CONFIG["action"];
    //     setOriginalList(config.getOriginalList);
    //     setItemList(config.getOriginalList);
    //     setIsLoading(false);
    //     setItemError("");
    // };

    const sortItems = useCallback((list) => {
        let sortedList = [...list];
    
        if (getSelectedSortOption === "movies") {
            sortedList = sortedList.filter(item => item.type === 'movie');
        } else if (getSelectedSortOption === "series") {
            sortedList = sortedList.filter(item => item.type === 'series');
        }
    
        return sortedList;
    }, [getSelectedSortOption]);

    useEffect(() => {
        getCardSpace();
        const handleResize = () => {
            getCardSpace(); 
        };
    
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const config = GENRE_CONFIG[genre.toLowerCase()] || GENRE_CONFIG["action"];
        const filteredList = config.getOriginalList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const sortedList = sortItems(filteredList);
        setItemList(sortedList);
        setIsLoading(false);
        setItemError("");
    }, [getSearch, GENRE_CONFIG, sortItems, genre]);

    useEffect(() => {
        const parent = document.getElementById('action_container_home_screen_i');
        if (getItemList.length <= 0) {
            parent.style.display = "flex";
            parent.style.flexDirection = "column";
            parent.style.alignItems = "center";
        } else {
            parent.style.display = "grid";
            parent.style.width = "100%";
        }
    }, [getItemList]); 

    return(
        <div className="home_item_section">
            <div className="home_item_section_head_container">
                <div className="home_item_section_head_container_row">
                    <img alt='back' onClick={goBack} src={backArrowIcon} className="home_item_section_back"/>
                    <p className="home_item_section_header">{genre.charAt(0).toUpperCase()}{genre.slice(1)}</p>
                </div>
                <div className="home_item_section_sort_container">
                    <label className="home_item_section_sort_label" htmlFor="home_item_section_sort_dropdown">Sort: </label>
                    <select 
                        id="home_item_section_sort_dropdown" 
                        className="home_item_section_sort_dropdown"
                        value={getSelectedSortOption} 
                        onChange={onSortItems}
                    >
                        <option value="all">All</option>
                        <option value="movies">Movies</option>
                        <option value="series">Tv Series</option>
                    </select>
                </div>
            </div>
            <div className="home_item_section_divider_a"></div>
            <div className="item_section_search_input_container_i">
                <div className="item_section_search_input_container">
                    <img alt='search' src={searchIcon} className="item_section_search_input_icon"/>
                    <input className="item_section_search_input_field" id="item_section_search" placeholder={`Search for any ${genre.toLowerCase()} movie or tv series...`} type="text" value={getSearch} onChange={onChangeSearch} />
                </div>
            </div>
            
            <div className="home_item_section_items_container">
                <div id="action_container_home_screen_i" className="action_container_home_screen_i">
                    {
                        getItemError === "" 
                        ? (
                            getItemList.length > 0
                            ? getItemList.map((movie, index) => (
                                <Link className="action_container_sub_home_screen_b" to={`/main_back/home/${genre.toLowerCase() === "science fiction" ? "science-fiction" : genre.toLowerCase()}/${movie.type}/${movie.id}`}><div key={index} id="movie_item_i" className="movie_item_i">
                                    <img
                                        loading='lazy'
                                        src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                        alt={movie.title}
                                        className="movie_poster_i"
                                        />
                                    <p className="movie_item_ip">{movie.title}</p>
                                </div></Link>
                            ))
                            : getIsLoading
                            ? <p>Loading...</p>
                            :<p>There are no {genre.toLowerCase()} {getSelectedSortOption === "all" ? "movies or series" : getSelectedSortOption}{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}available at the moment sorry 🥲</p>
                        )
                        : <p>{getItemError}</p>
                    }
                </div>
            </div>
        </div>
    );
};

export default ItemSection;